module.exports = {
    "baseUrl": "https://api-v4.staging.primrose.health",
    "baseUrl2": "https://stagingnew.trillium.health",
    "dashboardUrl": "https://stagingnew.trillium.health",
    "systemName": "System dev",
    "chatServer": "https://staging.trillium.health:8082/chatWebsocket",
    "videoServer": "https://staging.trillium.health:9090/schedularWebsocket",
    "newChatServer": "https://api-v4.chat.staging.primrose.health",
    "prodStatus": true,
    "patientChatUrl": "https://m.staging.trillium.health",
    "stripeKey": "pk_test_51Ia02yIg43ZjHHGkNp1xNEhAYWFGkVQQBSKrNy9zCbK82wjPXTq7mROyYGjQd23qTEjiJt9zTaQHEVos9Ty4eXd700iya1BPmo",
    "companyTitle": "Clinic Scheduler | Trillium Health",
    "metaTitle": "Trillium Health Scheduler Web App",
    "metaDescription": "Scheduler for physicians and clinics from Trillium Health",
    "favicon": "%PUBLIC_URL%/favicon.primrose.png",
    "companyName": "Trillium Technologies",
    "copyRight": "Primrose Health and Trillium Technologies are trademarks of their respective owners.",
    "companyKey": "trillium",
    "aboutHref": "#0",
    "contactHref": "#0",
    "selfPayApi": "https://app.staging.primrose.health"
}